import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PasswordStrengthTooltipComponent } from '../password-strength-tooltip/password-strength-tooltip.component';

@Component({
  selector: 'app-input-field',
  standalone: true,
  imports: [CommonModule, FormsModule, PasswordStrengthTooltipComponent],
  templateUrl: './input-field.html',
  styleUrl: './input-field.css'
})
export class InputFieldComponent {
  @Input() label: string = '';
  @Input() type: string = 'text';
  @Input() placeholder: string = '';
  @Input() value: string = '';
  @Input() required: boolean = false;
  @Input() icon: string = '';
  @Input() showPasswordToggle: boolean = false;
  @Input() errorMessage: string = '';
  @Input() hasError: boolean = false;
  @Input() showPasswordStrengthTooltip: boolean = false;
  
  @Output() valueChange = new EventEmitter<string>();
  @Output() inputFocus = new EventEmitter<void>();
  @Output() inputBlur = new EventEmitter<void>();
  @Output() clearError = new EventEmitter<void>();
  
  showPassword: boolean = false;
  showTooltip: boolean = false;
  
  onInputChange(event: any) {
    this.value = event.target.value;
    this.valueChange.emit(this.value);
    if (this.hasError && this.value.trim() !== '') {
      this.clearError.emit();
    }
  }
  
  onFocus() {
    this.inputFocus.emit();
  }
  
  onBlur() {
    this.inputBlur.emit();
  }
  
  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
    this.type = this.showPassword ? 'text' : 'password';
  }

  onMouseEnter() {
    if (this.showPasswordStrengthTooltip && this.type === 'password') {
      this.showTooltip = true;
    }
  }

  onMouseLeave() {
    this.showTooltip = false;
  }
}
